<template>
  <svg :style="style" width="53" height="18" viewBox="0 0 53 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="&#233;&#149;&#191;&#231;&#174;&#173;&#229;&#164;&#180;" clip-path="url(#clip0_3229_29455)">
      <path id="Vector 39" d="M3.83398 9H5.83398M48.334 9L41.834 3.5M48.334 9L41.834 14.5M48.334 9H9.33398"
        stroke="url(#paint0_linear_3229_29455)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_3229_29455" x1="48.334" y1="9" x2="-6.16601" y2="9"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_3229_29455">
        <rect width="52" height="18" fill="white" transform="translate(0.333984)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'arrow-right',
  data() {
    return {
      style: {
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
      }
    }
  }
}
</script>